// Takes in Date in ISO 8601 Format
// returns date if params are valid, else return null
/**
 * Returns the date object from ISO date string
 * @param {string} isoDate date in ISO string format
 * @param {string} timezone timezone string according to moment (See {@link https://gist.github.com/diogocapela/12c6617fc87607d11fd62d2a4f42b02a})
 * @returns {Date | null} JavaScript Date object
 */
export const getDate = (isoDate) => {
  if (!isoDate) return null;
  let date = new Date(isoDate);
  let dateTime = date.getTime();
  if (!isNaN(dateTime)) {
    return date;
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/utils/dateParser.js